const ROUTER = {
  INIT: 'ROUTER.INIT',
  GO_TO: 'ROUTER.GO_TO',
  GO_BACK: 'ROUTER.GO_BACK',
  GO_TO_ERROR: 'ROUTER.GO_TO_ERROR',
  TRY_TO_REDIRECT: 'ROUTER.TRY_TO_REDIRECT',
  RESOLVE_MOVIE_END: 'ROUTER.RESOLVE_MOVIE_END',
};

export default ROUTER;

export const PATH = {
  INFO: 'info',
  PLAYER: 'player',
  EPISODES: 'episodes',
  LOGIN: 'login',
  ENTER: 'enter',
  REGISTRATION: 'registration',
  GET_PASSWORD: 'getPassword',
  MOVIE_TARIFF_SELECT: 'movieTariffSelect',
  SUBSCRIPTION_TARIFF_SELECT: 'subscriptionTariffSelect',
  PAYMENT_METHOD_SELECT: 'paymentMethodSelect',
  PAYMENT_EXECUTION: 'paymentExecution',
  ERROR_PAGE: 'errorPage',
  UNIVERSAL: 'universal',
};

// at this moment allowable fields are 'requiredParams' & 'optionalParams'
export const PATH_RULES = {
  [PATH.INFO]: {
    url: '/info',
    requiredParams: ['id'],
    backTransitionZone: 1,
    unrestricted: true,
  },
  [PATH.PLAYER]: {
    url: '/player',
    requiredParams: ['id'],
    optionalParams: ['video_id', 'start', 'autoplay'],
    backTransitionZone: 1,
    unrestricted: true,
  },
  [PATH.EPISODES]: {
    url: '/episodes',
    isModal: true,
    requiredParams: ['id'],
    backTransitionZone: 1,
  },
  [PATH.SHARE]: {
    url: '/share',
    isModal: true,
    requiredParams: ['id'],
    backTransitionZone: 1,
  },
  [PATH.ENTER]: {
    url: '/enter',
    optionalParams: ['id'],
    backTransitionZone: 0,
  },
  [PATH.LOGIN]: {
    url: '/login',
    optionalParams: ['id'],
    backTransitionZone: 0,
  },
  [PATH.REGISTRATION]: {
    url: '/registration',
    optionalParams: ['id'],
    backTransitionZone: 0,
  },
  [PATH.GET_PASSWORD]: {
    url: '/getpassword',
    optionalParams: ['id'],
    backTransitionZone: 0,
  },
  [PATH.MOVIE_TARIFF_SELECT]: {
    url: '/purchase/movie',
    requiredParams: ['id', 'type'],
    backTransitionZone: 1,
  },
  [PATH.SUBSCRIPTION_TARIFF_SELECT]: {
    url: '/purchase/subscription',
    backTransitionZone: 1,
    requiredParams: ['id'],
  },
  [PATH.PAYMENT_METHOD_SELECT]: {
    url: '/payment/select',
    requiredParams: ['id', 'type', 'tariff_id'],
    backTransitionZone: 1,
  },
  [PATH.PAYMENT_EXECUTION]: {
    url: '/payment/exec',
    requiredParams: ['id', 'type', 'tariff_id'],
    backTransitionZone: 1,
  },
  [PATH.ERROR_PAGE]: {
    url: '/error',
    backTransitionZone: 1,
  },
  [PATH.UNIVERSAL]: {
    url: '/universal',
    requiredParams: ['id'],
    backTransitionZone: 1,
  },
};
